import { colombiaArrangedOptions } from '../countryOptions/colombiaOptions';
import { orderByLocale, removeDuplicatedObjectsByKey, removeExcludedField } from '../helpers';
import { generateInput } from '../../../../shared/utils/Form/useForm';
import { peruOptions } from '../countryOptions/peruOptions';

export const getPeruSpecificOptions = (
  inputs: Array<Record<string, unknown>>,
  fields: Record<string, unknown>,
  onValuesChange: (newValue: unknown) => void,
  bankEntities: Array<Record<string, string>>
) => {
  const peruInputOptions = { ...peruOptions(bankEntities) };
  const inputsCopy = inputs;

  const withoutExcluded = removeExcludedField(inputsCopy, [peruInputOptions.exclude]);
  const inputOptions = [
    generateInput(onValuesChange, fields.documentType)(peruInputOptions.documentType),
    generateInput(onValuesChange, fields.personalId)(peruInputOptions.personalIdTypeInputOptions),
    generateInput(onValuesChange, fields.bankAccountType)(peruInputOptions.colombiaBankAccountTypeInputOptions),
    generateInput(onValuesChange, fields.bic_swift)(peruInputOptions.bicSwiftInputOptions),
    ...withoutExcluded
  ];

  const withoutDuplicatedObjects = removeDuplicatedObjectsByKey(inputOptions, 'name');
  const orderedInputOptions = orderByLocale(colombiaArrangedOptions, withoutDuplicatedObjects);

  return orderedInputOptions;
};
